"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NPS_COMMON_POST = exports.NPS_COMMON_GET = exports.NPS_CHECK = exports.GET_NPS_MY_ORDER_JSON = void 0;
const NPS_COMMON_GET = exports.NPS_COMMON_GET = 'NPSCommonGet';
const NPS_COMMON_POST = exports.NPS_COMMON_POST = 'NPSCommonPost';
const NPS_CHECK = exports.NPS_CHECK = 'NPSCheck';
const GET_NPS_MY_ORDER_JSON = exports.GET_NPS_MY_ORDER_JSON = 'getNPSMyOrderJson';